import { MatPaginatorIntl } from '@angular/material/paginator';

export function createFrenchPaginatorIntl(): MatPaginatorIntl {
  const paginator = new MatPaginatorIntl();
  paginator.itemsPerPageLabel = 'Lignes par page';
  paginator.nextPageLabel = 'Page suivante';
  paginator.previousPageLabel = 'Page précédente';
  paginator.firstPageLabel = 'Première page';
  paginator.lastPageLabel = 'Dernière page';
  paginator.getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return `0 sur ${length}`;
    }

    const start = page * pageSize + 1;
    const end = Math.min(start + pageSize - 1, length);

    return `${start} - ${end} sur ${length}`;
  };

  return paginator;
}
